import { AuditingTable } from "components/auditing";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { CheckService } from "services/CheckService";
import { useTemplateConfig } from "pages/checks/hooks/useTemplateConfig";

export function TemplateHistory(props) {
    const noDataMessage = "It looks like no previous changes have been made to the template.";
    const [tableData, setTableData] = useState(null);
    const [tableRecordCount, setTableRecordCount] = useState(0);
    const { useGlobalEndpoint } = useTemplateConfig(props.useGlobalConfig);

    const onTableChange = (pageSize, pageNumber, startDate, endDate) => {
        CheckService.getTemplateChangelog(props.templateId, pageSize, pageNumber, startDate, endDate, useGlobalEndpoint).then(r => {
            setTableData(r.data);
            setTableRecordCount(r.totalCount);
        });
    }

    return (
        <AuditingTable 
            data={tableData}
            totalCount={tableRecordCount}
            onChange={onTableChange}
            allowClear={false}
            noDataMessage={noDataMessage}>
        </AuditingTable>
    );
}

TemplateHistory.propTypes = {
  templateId: PropTypes.string.isRequired,
  useGlobalConfig: PropTypes.bool
};